// Admin 资产中心:统一资产库(图 + 视频 + 音频)。
// 后端 drama `/api/workspace/admin/assets/images`,跨 9 个数据源 $unionWith。
import { request } from '@umijs/max';

const BASE = process.env.Auth_URL || '';

interface Envelope<T> {
  success: boolean;
  data?: T;
  message?: string;
  error?: { code: string; message?: string };
}

export type AssetSource =
  | 'canvas_image'
  | 'canvas_video'
  | 'canvas_audio'
  | 'character_shot'
  | 'character_sheet'
  | 'character_canonical'
  | 'project_cover'
  | 'scene_canonical'
  | 'scene_panorama';

export type AssetMediaType = 'image' | 'video' | 'audio';

export interface AssetItem {
  id: string;
  source: AssetSource;
  media_type: AssetMediaType;
  user_id: string;
  url: string;
  poster_url?: string;
  created_at: string;
  prompt?: string;
  provider?: string;
  caller?: string;
  model?: string;
  credit_cost?: number;
  duration?: number;
  project_id?: string;
  character_id?: string;
}

export interface AssetListResp {
  items: AssetItem[];
  total: number;
  page: number;
  page_size: number;
}

export interface AssetQuery {
  user_id?: string;
  source?: AssetSource | AssetSource[];
  page?: number;
  page_size?: number;
}

export async function listAdminAssetImages(params: AssetQuery) {
  const u = new URLSearchParams();
  if (params.user_id) u.set('user_id', params.user_id);
  if (params.source) {
    const v = Array.isArray(params.source)
      ? params.source.join(',')
      : params.source;
    if (v) u.set('source', v);
  }
  if (params.page) u.set('page', String(params.page));
  if (params.page_size) u.set('page_size', String(params.page_size));
  const qs = u.toString();
  return request<Envelope<AssetListResp>>(
    `${BASE}/api/workspace/admin/assets/images${qs ? `?${qs}` : ''}`,
    { method: 'GET', skipErrorHandler: true },
  );
}
